import InsuranceFamily, { IInsuranceFamily } from "@/model/InsuranceFamily/InsuranceFamily"
import hasTravellersEligible, { IHasTravellersEligible } from "@/model/mixins/Traveller/hasTravellersEligible"
import hasTravellersSelected, { IHasTravellersSelected } from "@/model/mixins/Traveller/hasTravellersSelected"
import ParticipantInsurance from "../Insurance/ParticipantInsurance"
import { IInsurance } from "../Insurance/Insurance"

class ParticipantInsuranceFamilyBase extends InsuranceFamily {

    constructor(id: string) {
        super(id)
    }

    public getQuantitySelected() {
        let quantitySelected = 0
        let allItems: IInsurance[] = []
        const allInsurances = this.getInsurances()
        allItems = allInsurances

        allItems.forEach((item: IInsurance) => {
            if (item instanceof ParticipantInsurance) {
                quantitySelected += item.getSelectedQuantity()
            }
        })
        return quantitySelected
    }

    public getQuantityNotSelected() {
        const quantitySelected = this.getQuantitySelected()
        const totalTravellersEligible = (this as unknown as IHasTravellersEligible).getTravellersEligible().length
        const numberNotSelected = totalTravellersEligible - quantitySelected
        return numberNotSelected
    }

}
export interface IParticipantInsuranceFamily extends ParticipantInsuranceFamilyBase, IInsuranceFamily, IHasTravellersEligible, IHasTravellersSelected {
}

// apply mixins
const ParticipantInsuranceFamily: Constructor<IParticipantInsuranceFamily> = hasTravellersSelected(hasTravellersEligible(ParticipantInsuranceFamilyBase))

export default ParticipantInsuranceFamily